<template>
  <section class="h_07">
    <div class="title_container">
      <div class="title f-section-title">
        <div>生长</div>
      </div>
      <div class="des f-section-sub-title">
        车辆充电时花朵逐渐绽放，耗电时逐渐闭合，
        让用户直观感受到能量的流动与变化
      </div>
    </div>
    <div class="video_container" v-ia>
      <div class="border_container_night">
        <m-video
          poster="@/v2/mobile/assets/video/poster/v_07.webp"
          src="@/v2/mobile/assets/video/v_7.mp4"
          muted
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          autoplay
          ref="video"
        ></m-video>
      </div>
      <replay
        class="alive_replay"
        @click="() => replayVideo(this.$refs.video)"
      />
    </div>
  </section>
</template>

<script>
import { videoPlayByVisibleAreaH5, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    videoPlayByVisibleAreaH5(this.$refs.video)
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.h_07 {
  position: relative;
  .title {
    padding-top: 120px;
    display: flex;
    flex-direction: column;
    width: max-content;
    line-height: 1.4;
    color: #fff;
    margin: 0 24px;
  }
  .des {
    margin: 20px 24px;
    width: calc(100% - 48px);
    min-width: 330px;
  }
  img {
    margin-bottom: 1rem;
  }
  .video_container {
    width: calc(100% - 48px);
    margin: 0 24px;
    video {
      width: 100%;
    }
    .alive_replay {
      margin-top: 22px;
      margin-left: 3px;
      color: #3b82fc;
    }
  }
}
</style>
